export const fitChunkSize = (
  fileSize: number,
  initialChunkSize: number,
  chunksLimit: number,
): number => {
  let resultChunkSize = initialChunkSize;
  if (fileSize > chunksLimit * initialChunkSize) {
    let chunkSize = fileSize / chunksLimit;
    if (chunkSize % initialChunkSize !== 0) {
      chunkSize += initialChunkSize - (chunkSize % initialChunkSize);
    }
    resultChunkSize = chunkSize;
  }

  return resultChunkSize;
};
